var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"stk-p-8"},[_c(_setup.ValuesEditorView)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }